export type LocationPage = {
    slug: string
    city: string
    region: string
    /** 40–60 chars: "Construction Web Design [City] | Fixed £1,000". */
    seoTitle: string
    /** 120–155 chars, see docs/seo-content-guidelines.md section 6.4. */
    seoDescription: string
    /** Deprecated: the meta keywords tag is no longer rendered. */
    seoKeywords?: string[]
    /** Answer-first intro shown beside the H1 (40–60 words, facts register only). */
    tldr: string
    /** Local construction context: building areas, housing stock, planning authority, roads. */
    local?: { heading: string; paragraphs: string[] }
    pricingFromGBP: number
    hero: {
        eyebrow: string
        headline: string
        highlight?: string
        sub: string
        secondaryCta?: { label: string; href: string }
    }
    value: {
        eyebrow: string
        heading: string
        intro?: string
        points: { title: string; body: string; icon?: string }[]
    }
    features: {
        eyebrow: string
        heading: string
        intro?: string
        items: { title: string; body: string }[]
    }
    faqs: { q: string; a: string }[]
    finalCta?: { headline: string; highlight?: string; sub?: string }
}

import { locationPages } from '@/lib/location-pages'

export { locationPages }

export const locationSlugs = Object.keys(locationPages)

export const locationList = locationSlugs.map((slug) => ({
    slug,
    city: locationPages[slug].city,
    region: locationPages[slug].region
}))
